import BiasBody from './BiasBody';

export default BiasBody;
